import { render } from "./Error.vue?vue&type=template&id=8c710550&scoped=true"
import script from "./Error.vue?vue&type=script&lang=js"
export * from "./Error.vue?vue&type=script&lang=js"

import "./Error.vue?vue&type=style&index=0&id=8c710550&scoped=true&lang=css"

import exportComponent from "/home/jay/Code/dm-sokoban-leveleditor/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c710550"]])

export default __exports__